export const localStorageService = {
    getAuthToken,
    getEmail,
    setAuthToken,
    setEmail,
    clearStorage,
    setIsChecked,
    getIsChecked,
    setUserName,
    getUserName,
    getUserRoleType,
    setUserRoleType,
    setStoresEmployee,
    getStoresEmployee,
    setSupplierAccess,
    getSupplierAccess,
    setSelectedDashboardId,
    getSelectedDashboardId,
    hasCompleteAuthSession,
    hasPartialAuthSession
};

function clearStorage() {
    localStorage.removeItem('token');
    localStorage.removeItem("userName");
    localStorage.removeItem("userRole");
    localStorage.removeItem("StoresEmployee");
    localStorage.removeItem("supplierAccess");
    localStorage.removeItem("selectedDashboardId");
    if (!getIsChecked()) {
        localStorage.removeItem('email');
    }
}

function getAuthToken() {
    return localStorage.getItem('token');
}

function getEmail() {
    return localStorage.getItem('email');
}

function setAuthToken(authToken) {
    return localStorage.setItem('token', authToken);
}

function setEmail(email) {
    return localStorage.setItem('email', email);
}

function getIsChecked() {
    return JSON.parse(localStorage.getItem('isChecked'));
}

function setIsChecked(isChecked) {
    return localStorage.setItem('isChecked', JSON.stringify(isChecked));
}

function getUserName() {
    return localStorage.getItem('userName');
}

function setUserName(userName) {
    return localStorage.setItem('userName', userName);
}

function getUserRoleType() {
    return localStorage.getItem('userRole');
}

function setUserRoleType(userRole) {
    return localStorage.setItem('userRole', userRole);
}
function setStoresEmployee(storesEmployee) {
    return localStorage.setItem('StoresEmployee', storesEmployee);
}
function getStoresEmployee() {
    let storesEmployee = localStorage.getItem('StoresEmployee');
    if (storesEmployee !== undefined && storesEmployee !== null)
        return JSON.parse(storesEmployee);
    else
        return null;
}

function setSupplierAccess(supplierAccess) {
    if (supplierAccess == null) {
        localStorage.removeItem('supplierAccess');
        return;
    }
    localStorage.setItem('supplierAccess', typeof supplierAccess === 'string'
        ? supplierAccess
        : JSON.stringify(supplierAccess));
}

function getSupplierAccess() {
    const raw = localStorage.getItem('supplierAccess');
    if (!raw) {
        return null;
    }
    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
}

function setSelectedDashboardId(dashboardId) {
    if (dashboardId == null) {
        localStorage.removeItem('selectedDashboardId');
        return;
    }
    localStorage.setItem('selectedDashboardId', String(dashboardId));
}

function getSelectedDashboardId() {
    return localStorage.getItem('selectedDashboardId');
}

function hasCompleteAuthSession() {
    return !!(getAuthToken() && getEmail() && getUserName());
}

function hasPartialAuthSession() {
    return !!(getAuthToken() || getUserName() || getStoresEmployee());
}